/*
 * @Descripttion:
 * @version:
 * @Author: suiyue
 * @email: 1373842098@qq.com
 * @Date: 2022-05-05 17:47:30
 * @LastEditors: sj
 * @LastEditTime: 2022-05-19 11:44:46
 */
import { unwrapResult } from '@reduxjs/toolkit'
import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { EditableList } from '../../../compnents/list/EditableList'
import { List } from '../../../models/page'
import { PaymentPageParams } from '../../../services/insurance'
import { ThemeContext } from '../../../theme/ThemeContext'
import { selectInsuranceArray } from '../../tenant/setting/TenentSettingSlice'
import { paymentRatioColumns } from '../Columns'
import {
  getPaymentPage,
  PaymentPageValue,
} from '../InsuranceSlice'
import { CurrentQuery } from '../province/CurrentQuery'
import styles from '../province/province.module.css'

export const PaymentRatio = () => {

  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<RootDispatch>()

  const insuranceArray = useSelector(selectInsuranceArray)

  const [data, setData] = useState<List<PaymentPageValue>>()

  const [queries, setQueries] = useState<PaymentPageParams>({
    size: 10,
    current: 1,
  })

  useEffect(() => {
    if (insuranceArray && insuranceArray.length !== 0) {
      getData()
    }
  }, [queries, insuranceArray])

  const getData = () => {
    dispatch(
      getPaymentPage({
        insuranceCode: insuranceArray[0].insuranceCode,
        ...queries,
        hilistCode: queries.name,
      })
    )
      .then(unwrapResult)
      .then((res) => {
        setData(res)
      })
  }

  return (
    <div className={styles.content}>
      <CurrentQuery
        code={1319}
        onValueChange={(vs) => {
          setQueries({ ...queries, ...vs })
        }}
        showNameSearch={false}
      />
      <EditableList
        style={{ color: theme.tc3 }}
        className={styles.table}
        columns={paymentRatioColumns((id) => {
          console.log(id)
        }, queries.size * (queries.current - 1))}
        page={{
          size: queries.size,
          current: queries.current || 1,
          total: data?.total || 0,
          items: data?.records || [],
        }}
        onChangePage={(current, size?: number) => {
          setQueries({
            ...queries,
            current,
            size: size || 10
          })
        }}
      />
    </div>
  )
}
